import { UseFormReturn, useWatch } from "react-hook-form";

import { useTranslation } from "../../core/translation.core";
import useSingleProductQuery from "../../hooks/useSingleProductQuery.hook";
import CloseIcon from "../../icons/iconClose.comp";
import { AttachProduct, Product, ProductFormData } from "../../types/product";
import OutlineLink from "../form/outlineLink.comp";

export default function AttachedProducts({
  methods,
  parentProduct,
}: {
  methods: UseFormReturn<ProductFormData>;
  parentProduct: Product;
}) {
  const { msg, t } = useTranslation();

  return (
    <section>
      <AttachProductList methods={methods} />
      <div className="mt-4">
        <OutlineLink
          id="attach-product"
          href={`/product/attach-create?parentId=${parentProduct?.id}`}
          text={t(msg.product.attachProducts)}
        />
      </div>
    </section>
  );
}

const AttachProductList = ({ methods }: { methods: UseFormReturn<ProductFormData> }) => {
  const { msg, t } = useTranslation();

  const products = useWatch({
    control: methods.control,
    name: "attachProducts",
  });

  if (!products) return null;

  return (
    <div className="w-full border">
      <table className="w-full" id="attached-list">
        <thead>
          <tr>
            <th> {t(msg.product.product)}</th>
            <th> {t(msg.addOnDiscount.placement)}</th>
            <th> {t(msg.product.suggestionType)}</th>
            <th>{t(msg.product.isOptional)}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {products.map((p) => (
            <ProductsRow key={p.productId} attachProduct={p} methods={methods} />
          ))}
        </tbody>
      </table>
    </div>
  );
};

const ProductsRow = ({ attachProduct, methods }: { attachProduct: AttachProduct; methods: UseFormReturn<ProductFormData> }) => {
  function deleteItem() {
    const products = methods.getValues("attachProducts");
    const removedArray = products.filter((db) => db.productId !== attachProduct.productId);
    methods.setValue("attachProducts", removedArray);
  }

  const { data: product } = useSingleProductQuery(attachProduct.productId);
  if (!product) return null;

  return (
    <tr id="attachProducts" className="w-full border">
      <td>{product.name.en}</td>

      <td>{attachProduct.placement}</td>

      <td>{attachProduct.suggestionType}</td>

      <td>{attachProduct.optional ? "Yes" : "No"}</td>

      <td>
        <button onClick={deleteItem} type="button">
          <CloseIcon />
        </button>
      </td>
    </tr>
  );
};
